import { getPreviewQuotes } from '@/graphql/queries/previews/car-insurance';

export default async ({ $apolloQuery, store }) => {
  const results = await $apolloQuery(getPreviewQuotes);
  store.commit('previews/setResults', results);
};
